import { useContext } from 'react';

import { SplitViewContext, type SplitViewContextValue } from './SplitViewContext';

export const useSplitView = (): SplitViewContextValue => useContext(SplitViewContext);
